import React from "react";
import Hero from "../components/hero/Hero";
import Brands from "../components/Brands/Brands";
import Familiar from "../components/familiar/Familiar";
import Work from "../components/work/Work";
import Integrations from "../components/Integrations/Integrations";
import Reviews from "../components/reviews/Reviews";
import Pricing from "../components/pricing/Pricing";
import About from "../components/about/About";
import Faq from "../components/faq/Faq";
import ButWhyUs from "../components/ButWhyUs";
import PreventDiscount from "../components/PreventDiscount";
import TheProblem from "../components/TheProblem";
import PowerfulSolution from "../components/PowerfulSolution";
import Testimonials from "../components/Testimonials";
import CustomerGeniusROICalculator from "../components/calculator/Calculator";

import "./responsive.css";

// import Pricing from "../components/Pricing";
// import Faq from '../components/Faq';
const HomePage = () => {
  return (
    <>
      <Hero id="hero" />
      <Brands id="brands" />
      <Familiar id="familiar" />
      <Work id="work" />
      <Integrations id="integrations" />
      <Reviews id="reviews" />
      <Pricing id="pricing" />
      <About id="about" />
      <Faq id="Faq" />
      <CustomerGeniusROICalculator id="CustomerGeniusROICalculator" />

      {/* <TheProblem id="the-problem" />
      <PowerfulSolution id="powerful-solution" />
      <ButWhyUs id="but-why-us" />
      <Testimonials id="testimonials" />
      <Pricing id="pricing" /> */}
      {/* <Faq id="faq"/> */}
    </>
  );
};
export default HomePage;
